import { PRICE_ID_TO_GRAMS } from '@iheartjane/menu';
import type { PriceId, ProductKind } from '@iheartjane/types';

export const getProductWeight = (
  productType: ProductKind,
  productPriceId: PriceId | 'undefined'
) => {
  return productType === 'flower' &&
    productPriceId !== 'undefined' &&
    productPriceId !== 'each'
    ? PRICE_ID_TO_GRAMS[productPriceId]
    : null;
};
